import React from 'react';

import Stack from '@mui/material/Stack';
import Providers from './components/Providers';

const PaymentProvidersPage: React.FC = () => (
  <Stack spacing={4}>
    <Providers />
  </Stack>
);

export default PaymentProvidersPage;
